import { PlainBrandIcon } from '@jotta/ui/BrandIcon'
import { getTranslatedFilenameFromApiPath } from '@jotta/grpc-js-client/getTranslatedFilenameFromApiPath'
import type { PathItemObject } from '@jotta/types/Files'
import type { FileRouteParams } from '@jotta/types/schemas/FileRouteSchema'
import { observer } from 'mobx-react-lite'
import { FileContextMenu } from '../FileContextMenu/FileContextMenu'
import { getFileActionMenuItems } from '../FileContextMenu/getFileActionMenuItems'
import { FileApiPathNavLink } from '../FileRouteLink/FileApiPathLink'
import styles from './FileBreadCrumb.module.scss'
import { FileBreadCrumbItem } from './FileBreadCrumbItem'
import SvgCaretRight from '@jotta/ui/SvgCaretRight'
import SvgFillCaretDown from '@jotta/ui/SvgFillCaretDown'

interface FileBreadCrumbNavProps {
  onContextMenuSelect?: (e: Event) => void
  params: FileRouteParams
  item: PathItemObject
  trailingArrow?: boolean
  shrink?: boolean
  hide?: 'large' | 'small'
}

export const FileBreadCrumbNav = observer<FileBreadCrumbNavProps>(
  function FileBreadCrumbNav({
    params,
    item,
    onContextMenuSelect,
    trailingArrow = false,
    shrink = false,
    hide,
  }) {
    const actions = onContextMenuSelect
      ? getFileActionMenuItems('BREADCRUMB', item)
      : []

    const name = getTranslatedFilenameFromApiPath(item.path, item.name)

    const showContextMenu = onContextMenuSelect && actions.length

    return (
      <FileBreadCrumbItem shrink={shrink} hide={hide}>
        {showContextMenu ? (
          <FileContextMenu
            path={item.path}
            context="BREADCRUMB"
            onSelect={onContextMenuSelect}
            actions={actions}
            triggerClassName="active"
          >
            <span title={shrink ? name : undefined}>{name}</span>
            <PlainBrandIcon icon={SvgFillCaretDown} className="p-1" />
          </FileContextMenu>
        ) : (
          <FileApiPathNavLink
            end
            title={shrink ? name : undefined}
            path={item.path}
          >
            {name}
          </FileApiPathNavLink>
        )}
        {trailingArrow && (
          <PlainBrandIcon icon={SvgCaretRight} className={styles.separator} />
        )}
      </FileBreadCrumbItem>
    )
  },
)
